"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultLanguage = void 0;
var preferredLanguage = navigator.languages ? navigator.languages[0] : navigator.language;
var defaultLanguage = preferredLanguage ? preferredLanguage.toLowerCase() : 'en-us';
exports.defaultLanguage = defaultLanguage;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/usage-tracker-public/static-1.325/js/helpers/langHelper.js
// module id = 966
// module chunks = 6